import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import { nameValidation, renderField } from '../../../common';

let Create = props => {
  const {
    handleSubmit, companies, callcenters, roles, submitting
  } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Создание клиента</h2>
        <div>
          <label>Имя*</label>
          <Field name="name" autoComplete="off" component={renderField} data-lpignore validate={nameValidation} type="text" />
        </div>
      </div>
      <div>
        <label>Телефон</label>
        <Field name="phone" component="input" type="text" data-lpignore disabled autoComplete="off" />
      </div>
      <div>
        <label>Email</label>
        <Field name="email" component="input" type="text" placeholder="" data-lpignore autoComplete="off" />
      </div>
      <div>
        <label>Вопрос</label>
        <Field name="subject_text" component="textarea" style={{ height: '58px' }} data-lpignore autoComplete="off" />
      </div>
      <div>
        <label>Комментарий Юр. Фирмы</label>
        <Field name="comment" component="textarea" style={{ height: '58px' }} data-lpignore autoComplete="off" />
      </div>
      <div>
        <button type="submit" disabled={submitting}>
          Создать клиента
        </button>
      </div>
    </form>
  );
};

Create = reduxForm({
  form: 'createClient'
})(Create);

Create = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
}))(Create);

export default Create;



// WEBPACK FOOTER //
// ./src/pages/company/customer/CreateClient.js